<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="isPdfPreview">
    <div
      v-for="(lb, index) in label"
      :key="index"
    >
      <label
        :class="{ required: required }"
        class="form-label"
      >{{ lb }}</label>
    </div>
    <div :class="['form-control']">
      {{ getFormattedValue(value) }}
    </div>
  </div>
  <div v-else>
    <ValidationProvider
      v-slot="v"
      :rules="rules"
    >
      <!-- <div v-for="(lb, index) in label" :key="index">
        <label :name="name" :class="[{ required: required }, labelClass]" class="form-label">{{ lb }}</label>
      </div> -->

      <label
        :name="name"
        :class="labelClass"
        class="form-label"
      >
        <div
          v-for="(lb, index) in label"
          :key="index"
          :class="{'required': index === 0 && required}"
          v-html="lb"
        />
      </label>
      <slot />
      <span
        v-if="v.validated && v.invalid"
        class="input-error"
        v-html="v.errors[0]"
      />
    </ValidationProvider>
  </div>
</template>

<script>
	export default {
		name: 'AppInputCheck',
		props: {
			// eslint-disable-next-line vue/require-prop-types
			value: {
				// type: Boolean,
				required: true
			},
			label: {
				type: [String, Array],
				required: true,
			},
			labelClass: {
				type: String,
				default: '',
			},
			name: {
				type: String,
				default: '',
			},
			rules: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				isPdfPreview: false,
			}
		},
		computed: {
			required() {
				return this.rules && this.rules.indexOf('required') >= 0
			},
		},
		mounted() {
			this.isPdfPreview = this.$root.inPdfPreviewForm(this.$el)
			// let inputElement = this.$el.getElementsByTagName('input')[0]
			// if (inputElement) {
			//   inputElement.id = this.name
			//   inputElement.setAttribute('name', this.name)
			// }
		},
		methods: {
			getFormattedValue() {
				if (this.value == null) {
					return 'No value'
				}

				if (this.value === true || this.value === false) {
					return this.value ? 'Yes' : 'No'
				}

				return this.value
			},
		},
	}
</script>
